import { RoundingDirection, RoundingUnitKind } from "@sinch/core/entities/serverEnums";
import { t } from "i18next";
import { boolean, type InferType, mixed, number, object, string } from "yup";

/**
 * Form schema of a rounding definition. Messages stay lazy: the schema is built at module load,
 * before i18next is initialized.
 */
export const roundingFormSchema = object({
  name: string().required().default(""),
  description: string().nullable().default(""),
  archived: boolean().default(false),
  unitKind: mixed<RoundingUnitKind>().oneOf(Object.values(RoundingUnitKind)).required().default(RoundingUnitKind.Time),
  base: number()
    .min(0)
    .required()
    .default(15)
    .when("unitKind", {
      is: RoundingUnitKind.Time,
      then: (schema) => schema.integer(() => t("RateRounding.wholeMinutes")),
    }),
  direction: mixed<RoundingDirection>().oneOf(Object.values(RoundingDirection)).required().default(RoundingDirection.Up),
  grace: number()
    .nullable()
    .default(null)
    .when(["direction", "unitKind", "base"], ([direction, unitKind, baseValue], schema) => {
      if (direction !== RoundingDirection.GraceUp) {
        return schema.transform(() => null);
      }
      const bounded = schema
        .required(() => t("required"))
        .min(0)
        .lessThan(Number(baseValue ?? 0), () => t("RateRounding.graceBelowBase"));
      return unitKind === RoundingUnitKind.Time ? bounded.integer(() => t("RateRounding.wholeMinutes")) : bounded;
    }),
});

export type RoundingFormData = InferType<typeof roundingFormSchema>;
